import { ModuleBase } from './ModuleBase'

export class UpdateModule extends ModuleBase {
  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  onPreloadData(): void {}

  inits2c(): void {}
}
